module.exports = __webpack_public_path__ + "static/media/oana_olariu.763d7939.png";